module.exports = __webpack_public_path__ + "6d713a36d381cb78e133c1daaf06aa93.png";